import { useState, useEffect } from 'react';

const usePageLoader = (minLoadTime = 2000) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const startTime = Date.now();
    
    // Function to check if all images are loaded
    const checkImagesLoaded = () => {
      const images = document.querySelectorAll('img');
      const imagePromises = Array.from(images).map(img => {
        if (img.complete) {
          return Promise.resolve();
        } else {
          return new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to not block loading
          });
        }
      });
      
      return Promise.all(imagePromises);
    };

    // Function to ensure minimum loading time
    const ensureMinLoadTime = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minLoadTime - elapsed);
      
      return new Promise(resolve => {
        setTimeout(resolve, remaining);
      });
    };

    // Wait for images and minimum load time
    Promise.all([checkImagesLoaded(), ensureMinLoadTime()])
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        // Fallback: hide loader after minimum time even if there are errors
        setTimeout(() => setIsLoading(false), minLoadTime);
      });
  }, [minLoadTime]);

  return isLoading;
};

export default usePageLoader; 